import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'

export const Footer = () => {
  const { t } = useTranslation()
  return (
    <footer className="site-footer">
      <div className="shell footer-inner">
        <a className="wordmark" href="/#home">
          <span>
            MARCOS{' '}
            <b>
              AQUINO<span className="brand-dot">.</span>
            </b>
          </span>
          <small>{t('portfolio.brand')}</small>
        </a>
        <p>{t('portfolio.footer.tagline')}</p>
        <nav
          aria-label={t('portfolio.footer.navigation')}
          className="social-links"
        >
          <a
            href="https://linkedin.com/in/marcos-aquino"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <PortfolioIcon name="linkedin" />
          </a>
          <a
            href="https://github.com/marcos-aquino"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="GitHub"
          >
            <PortfolioIcon name="github" />
          </a>
          <a
            href="mailto:me@marcosaquino.com"
            aria-label={t('portfolio.contact.email')}
          >
            <PortfolioIcon name="mail" />
          </a>
        </nav>
        <small className="footer-copyright">
          © {new Date().getFullYear()} {t('portfolio.footer.copyright')}
          {' · '}
          <a href="/image-credits.html">{t('portfolio.footer.photoCredits')}</a>
        </small>
      </div>
    </footer>
  )
}
